import { YtPlayer } from '../../common/classes/ytPlayer.es6';
import { handleYtPlayer } from '../../common/function/handleYtPlayer.es6';
import Thumbnail from './thumbnail.es6';

export function main() {
    const player = new YtPlayer();
    handleYtPlayer(player);
    new Thumbnail();
}
